export const getHotelTabsLabels = (t) => ({
	DESCRIPTION: t('Description'),
	REVIEWS: t('Reviews'),
	AMENITIES: t('Amenities'),
	POLICIES: t('HotelPolicies'),
});
